/**
 * @file Asset detail adapter contract.
 */

import {
    getAssetDetailFields,
    setupAssetDetailScalarControls,
    setupAssetDetailTypeControls,
} from './assetDetails.js';
import {
    attachAssetMaintenanceSectionListeners,
    renderAssetMaintenanceSection,
} from './assetMaintenanceSection.js';

/**
 * Detail adapter for Asset parent items.
 */
export const assetDetailAdapter = {
    itemType: 'asset',
    viewName: 'assets',
    statusConfigKey: 'equipmentStatus',
    typeConfigKey: 'assetTypes',
    liveSaveFields: [
        'equipment_status',
        'types',
    ],
    sections: [
        'maintenance',
        'linkedTasks',
        'checklist',
        'notes',
        'attachments',
    ],
    renderFields: getAssetDetailFields,
    mountControls(detailsViewContainer, item) {
        setupAssetDetailScalarControls(detailsViewContainer, item);
        setupAssetDetailTypeControls(detailsViewContainer, item);
    },
    renderSection(sectionId, item) {
        if (sectionId !== 'maintenance') {return null;}
        return renderAssetMaintenanceSection(item);
    },
    attachPostFormListeners(detailsViewContainer, item, context) {
        attachAssetMaintenanceSectionListeners(detailsViewContainer, item, context);
    },
    getBackNavigation() {
        return { type: 'view', view: 'assets' };
    },
    getDeleteNavigation() {
        return { type: 'view', view: 'assets' };
    },
};
